import { SET_CALL_METHOD } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function setCallingMethod(callMethod) {
  return callingAPIMethodWithQueue(SET_CALL_METHOD, {
    callMethod
  });
}